import { AggregationMode, PeriodReference, IPeriodConfiguration, TimeInterval, NameBuilderConfiguration, KpiConfiguration } from '../../models';

export class BusinessKpiConfiguration implements IPeriodConfiguration {
    aggregationMode: AggregationMode;
    alignedOn: PeriodReference;
    isEndDateIncluded = false;
    kpis: KpiConfiguration[];
    maxPeriod: TimeInterval;
    minPeriod: TimeInterval;
    nameConfiguration: NameBuilderConfiguration;

    constructor() {
        this.kpis = [];
        this.aggregationMode = AggregationMode.Average;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.alignedOn = 0;
    }
}